import React from "react";
import classes from "./ToggleSwitch.module.css";
export default function ToggleSwtich(props) {
  return (
    <div>
      <label className={`${classes.switch}`}>
        <input
          type="checkbox"
          checked={props.checked ? true : false}
          onChange={(e) => props.clicked(e.target.checked)}
        />
        <span className={`${classes.slider} ${classes.round}`}></span>
      </label>
    </div>
  );
}
